import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

// In dev, keep Sentry enabled for error reporting but disable the expensive
// instrumentation (browserTracing wraps every fetch, browserProfiling samples
// the main thread, replay records DOM mutations). At 100% sample rate these
// add significant main-thread contention to every interaction, making the
// calendar page feel sluggish during local development even when the server
// responds in ~360ms. Errors still get captured via httpClient/httpContext.
const isProd = environment.production;

Sentry.init({
  dsn: 'https://7e020d600bc13e07f3f60f5aac60eb6e@sentry.webapp.ge/3',
  integrations: [
    // Error/context integrations — cheap, keep everywhere
    Sentry.httpClientIntegration({
      failedRequestTargets: [
        'localhost',
        /^https:\/\/api-client\.beautyapp\.ge/,
      ],
      failedRequestStatusCodes: [],
    }),
    Sentry.httpContextIntegration(),
    // Expensive perf/replay integrations — production only
    ...(isProd
      ? [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            networkCaptureBodies: true,
            networkDetailAllowUrls: [
              'localhost',
              /^https:\/\/api-client\.beautyapp\.ge/,
            ],
          }),
          Sentry.browserProfilingIntegration(),
        ]
      : []),
  ],
  environment: isProd ? 'production' : 'development',
  // Tracing — 0 in dev so browserTracingIntegration (if ever enabled) wouldn't sample
  tracesSampleRate: isProd ? 1.0 : 0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/api-client\.beautyapp\.ge/,
  ],
  // Session Replay — disabled in dev
  replaysSessionSampleRate: isProd ? 0.1 : 0,
  replaysOnErrorSampleRate: isProd ? 1.0 : 0,
  profilesSampleRate: isProd ? 1.0 : 0,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
